//var API_BASE_URL = "http://192.168.0.250:4000"

//if (process.env.NODE_ENV === "prod") {
//    API_BASE_URL = "http://vps3634.publiccloud.com.br:4000"
//}

// Urbano - 0 | Fretado - 1
export const modo = parseInt(process.env.VUE_APP_MODO) || 0;

export function getIdModo() {
  const stored = sessionStorage.getItem('setup_id_modo');
  if (stored != null && stored !== '') return parseInt(stored, 10);
  return 2;
}

export function isModoUrbano() {
  return getIdModo() === 1;
}

export function isModoFretado() {
  return getIdModo() === 2;
}

export function consultaPassageiroRequiresAuth() {
  return isModoFretado();
}

export const ApiBaseUrl = process.env.VUE_APP_ROOT_API; //API_BASE_URL
export const routerMode = process.env.VUE_APP_ROUTER_MODE;
export const ChaveRecaptcha = process.env.VUE_APP_RECAPTCHA;
export const defaultCountry = process.env.VUE_APP_DEFAULT_COUNTRY || "BR";
export const IsDevEnv = process.env.VUE_APP_ENV ? process.env.VUE_APP_ENV === "dev" : false;
export const GeoCodeForwardUrlPrefix = "https://api.mapbox.com/search/geocode/v6/forward";
export const GeoCodeBaseUrl = `${GeoCodeForwardUrlPrefix}?q=`;
export const GeoCodeBatchUrl = "https://api.mapbox.com/search/geocode/v6/batch?";
export const RevGeoCodeBaseUrl = "https://api.mapbox.com/search/geocode/v6/reverse?";
export const GeoCodeApiKey = process.env.VUE_APP_GEOCODE_API_KEY;
export const VersionNumber = '2.83.1';
export const SplashScreenParams = {
    mainLogoSrc: process.env.VUE_APP_SPLASH_MAIN_LOGO_SRC || "/imagens/merustracker-white.png",
    mainLogoAlt: process.env.VUE_APP_SPLASH_MAIN_LOGO_ALT || "Logo Merustracker",
    title: process.env.VUE_APP_SPLASH_TITLE || "splashScreen.default.ms1",
    subtitle: process.env.VUE_APP_SPLASH_SUBTITLE || "splashScreen.default.ms2",
    versionMessage: process.env.VUE_APP_SPLASH_VERSION_MESSAGE || "splashScreen.default.ms3",
    version: VersionNumber,
    partnerLogoLeftSrc: process.env.VUE_APP_SPLASH_PARTNER_LOGO_LEFT_SRC || "",
    partnerLogoLeftAlt: process.env.VUE_APP_SPLASH_PARTNER_LOGO_LEFT_ALT || "",
    partnerLogoRightSrc: process.env.VUE_APP_SPLASH_PARTNER_LOGO_RIGHT_SRC || "",
    partnerLogoRightAlt: process.env.VUE_APP_SPLASH_PARTNER_LOGO_RIGHT_ALT || "",
    background: process.env.VUE_APP_SPLASH_BACKGROUND || "#4A4A4A",
}
export const LineColors = [
    "#B71C1C",
    "#BF360C",
    "#880E4F",
    "#FF6F00",
    "#4A148C",
    "#F57F17",
    "#311B92",
    "#827717",
    "#1A237E",
    "#33691E",
    "#01579B",
    "#1B5E20",
    "#006064",
    "#E65100",
    "#004D40",
    "#880E4F",
    "#4A148C",
    "#EF5350",
    "#7E57C2",
    "#66BB6A",
    "#FFEE58",
    "#29B6F6",
    "#FF7043",
    "#42A5F5",
    "#EC407A",
    "#42A5F5",
    "#AB47BC",
    "#BDBDBD"
];

export const availableLocales = [
    { code: "pt-BR", language: "Português", countryCode: 'BR', shortName: 'BR' },
    { code: "es-MX", language: "Español", countryCode: 'MX', shortName: 'ES' },
]

export function validador(valor, inicio, fim, tipo, obrigatorio) {
    var regex = "";

    if (obrigatorio == 1 && (valor == '' || valor == null || valor.length < 1)) {
        return false;
    }
    else {
        if (tipo == 0) {
            regex = new RegExp("^[a-zA-Z0-9_-]{" + inicio + "," + fim + "}$")
        }
        else if (tipo == 1) {
            regex = new RegExp("^[a-zA-Z0-9\u00C0-\u00FF _.,-/]{" + inicio + "," + fim + "}$")
        } else {
            return valor.length < fim
        }

        return regex.test(valor);
    }
}
